import {parseMessage} from 'lib/stringHelper';
import PropTypes from 'prop-types';
import {memo} from 'react';
import PipettingProfileInputType from '../PipettingProfileInputType';
import PopupPipettingTipTouchOffInfo from './ItemInfo/PopupPipettingTipTouchOffInfo';

function PipettingItemTipTouchDirection({labware, position, maxValueOffset, value, onChangeDirection, onOverValue}) {
  return (
    <>
      <div className="pipetting-profile__item">
        <li>
          {parseMessage('protocolEditor.taskList.pipettingProfile.tipTouchOff.direction', {
            position: position.toUpperCase(),
          })}
        </li>
        <PopupPipettingTipTouchOffInfo labware={labware} position={position} />
      </div>
      <PipettingProfileInputType.NumericTextBox
        minValue={-maxValueOffset}
        maxValue={maxValueOffset}
        value={value}
        onChange={(val) => onChangeDirection(val)}
        onOverValue={onOverValue}
      />
    </>
  );
}

PipettingItemTipTouchDirection.propTypes = {
  labware: PropTypes.object.isRequired,
  position: PropTypes.string.isRequired,
  maxValueOffset: PropTypes.number,
  value: PropTypes.number.isRequired,
  onChangeDirection: PropTypes.func.isRequired,
  onOverValue: PropTypes.func,
};

PipettingItemTipTouchDirection.defaultProps = {
  maxValueOffset: 0,
  onOverValue: () => {},
};

export default memo(PipettingItemTipTouchDirection);
